import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { TitleService } from '@services/title.service';
import { SearchPipe } from '@pipes/search.pipe';
import { NumberOfKeysPipe } from '@pipes/number-of-keys.pipe';
import { OrderBy } from '@pipes/orderBy.pipe';
import { JobSummary } from '@interfaces/jobs.interface';

@Component({
    selector: 'app-location-filter',
    templateUrl: './location-filter.component.html',
    styleUrls: ['./location-filter.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, TranslatePipe, SearchPipe, NumberOfKeysPipe, OrderBy]
})
export class LocationFilterComponent implements OnInit {
  private titleService = inject(TitleService);

  @Input() jobs: JobSummary[] = [];
  @Input() locations: string[] = [];
  @Output() locationFilterChanged = new EventEmitter<string | undefined>();
  public filter: string | undefined;

  ngOnInit() {
    this.titleService.setTitle('');
  }

  selectLocation() {
    console.log(this.filter);
    this.locationFilterChanged.emit(this.filter);
  }
}
